import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './vi-simple.hbs'
import i18n from 'scoreboard/components/i18n'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import FormView from 'scoreboard/components/form-view'
import appDisplay from 'scoreboard/components/app-display'
import Results from 'scoreboard/components/import-results-dialog'
import FileFormat from 'scoreboard/imports/file-format'
import FileDrop from 'scoreboard/components/files/file-drop'
import dateFormatMessage from 'scoreboard/imports/date-format-message'

var ViSimple = Backbone.View.extend({

	tagName: 'form',

	className: 'simple-import-form',

	events: {
		'click .cancel': 'close'
	},

	/**
	 * Simple metric value import form used to upload metric values from the
	 * Home | Metric Updates screen.
	 *
	 * @constructs
	 */
	initialize(options = {}) {
		this.options = options

		this.formView = new FormView({
			el: this.el,
			guard: false,
			allowCleanSubmission: () => !_.isNil(this.fileId),
			submit: this.submit.bind(this)
		})
	},

	render() {
		this.$el.empty().append(template(this.context()))

		this._renderFileDrop()
		this._renderWizard()
		this.formView.start()
		this._renderMetricUpload()
		this._attachListeners()
		return this
	},

	_renderFileDrop() {
		this.fileDrop = new FileDrop({
			fileUploaderOptions: {
				url: 'api/imports/spreadsheets',
				accept: ['spreadsheetWithoutNumbers']
			}
		})
		this.$('.dialog-body-content').append(this.fileDrop.el)
		this.fileDrop.render()
	},

	_renderWizard() {
		this.options.wizard && this.options.wizard.render({
			formView: this.formView
		})
	},

	_renderMetricUpload() {
		if (this._isMetricUpload()) {
			let fileFormat = new FileFormat({
				label: i18n.get('scorecards.exportValues.step2.chooseFormat.optional')
			})
			this.$('.metric-instructions-chooser').append(fileFormat.el)
			fileFormat.render()

			fileFormat.on('select', value => this._showMetricInstructions(value.value))

			this.$('.metric-instructions-chooser').removeClass('is-not-displayed')
			this._showMetricInstructions(fileFormat.val())
		}
	},

	_attachListeners() {
		this.fileDrop.on('done', this.uploadFinished.bind(this))
			.on('error', this.uploadError.bind(this))
			.on('start', this.uploadStart.bind(this))
	},

	_showMetricInstructions(type) {
		this.$('.banner').addClass('is-not-displayed')
		this.$(`.banner.metric-${type}-instructions`).removeClass('is-not-displayed')
	},

	_isMetricUpload() {
		return this.model.get('type') === 'metric-value'
	},

	context() {
		let title, instructions, metricRowsFileName, metricColsFileName, fileName, dateColumn
		if (this._isMetricUpload()) {
			title = i18n.get('home.metricUpdates.import')
			this.$('.banner').addClass('is-not-displayed')
			this.$('.banner.metric-instruction-banner').removeClass('is-not-displayed')
			metricRowsFileName = 'metric_value_example.csv'
			metricColsFileName = 'metric_value_header_dates_example.csv'
		} else {
			title = i18n.get('initiatives.overview.import')
			instructions = i18n.get('initiatives.overview.import.instructions.fileType')
			fileName = 'initiative_status_example.csv'
			dateColumn = i18n.get('admin.import.columnHeader.initiative.date')
		}

		let metricRowsDownloadLink = metricRowsFileName ? scoreboardUrl(metricRowsFileName) : ''
		let metricColsDownloadLink = metricColsFileName ? scoreboardUrl(metricColsFileName) : ''
		let downloadLink = fileName ? scoreboardUrl(fileName) : ''
		return {title, instructions, dateFormatMessage: dateFormatMessage(), metricRowsDownloadLink,
			metricColsDownloadLink, downloadLink, dateColumn
		}
	},

	uploadStart: function() {
		// note this has to be a callback since the primaryButton isn't
		// defined yet
		this.formView.primaryButton.loading()
		// #19710 disable the cancel button
		this.$('.cancel').prop('disabled', true)
		this.formView.clearErrors()
	},

	// callback for when the upload finished.  data is any data returned by
	// the server
	uploadFinished: function(data) {
		this.$('.cancel').prop('disabled', false)
		this.formView.primaryButton.enable()
		this.fileId = data.fileId
	},

	uploadError: function(response) {
		// #32461 display any spreadsheet validation errors
		if (response.statusText !== 'abort') {
			this.formView.error(response)
		}
	},

	close() {
		this.model.deleteFile()
		this.trigger('done')
	},

	deleteFile() {
		if (this.fileId) {
			$.delete(`api/files/revisions/${this.fileId}`)
		}
	},

	submit() {
		let type = this.model.get('type')
		let url = `api/imports/simple/${this.fileId}/${type}`
		return $.ajax({
			method: 'post',
			url,
			success: results => {
				let resultsDialog = new Results({
					results
				})
				appDisplay.replaceDialog(resultsDialog)
				resultsDialog.on('done', () => this.options.wizard.finish('import-complete'))
			},
			error: (xhr) => {
				this.formView.error(xhr)
			}
		})
	},

	remove() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.fileDrop, this.formView], 'remove')
	}

})

export default ViSimple

ViSimple.__filename__ = 'imports/vi/vi-simple.js'
